import { withCompInfo } from '@wix/editor-elements-integrations'
import { colorApi } from '@wix/thunderbolt-becky-root'
import { FooterContainerCSSVars, FooterContainerDefinition } from './FooterContainer'
import { isFixedPosition } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<FooterContainerCSSVars, FooterContainerDefinition>()(
	[
		'styleProperties',
		'compLayout',
		'siteColors',
		'compSingleLayout',
		// @ts-ignore - Remove once siteFonts is added to the compInfo
		'isOneDocMigrated',
	],
	({
		styleProperties,
		compLayout,
		siteColors,
		compSingleLayout,
		// @ts-ignore - Remove once siteFonts is added to the compInfo
		isOneDocMigrated,
	}) => {
		const fixedPosition = isFixedPosition(compLayout, compSingleLayout)

		const brightnessParams = colorApi.getBrightnessCSSVars({
			siteColors,
			styleProperties,
		})

		const style =
			(!isOneDocMigrated &&
				fixedPosition && {
					position: 'fixed !important' as const,
					bottom: '0' as const,
				}) ||
			(isOneDocMigrated &&
				compSingleLayout?.itemLayout?.type !== 'FixedPositionItemLayout' && {
					position: 'relative',
				})

		return {
			...brightnessParams,
			...style,
		}
	}
)
